/**
 * 所有币种列表
 */
import { getPrice, getTET, getSupply } from '@/utils/api';

export function getInitialState() {
  return {
    price: 0,
    supply: 0,
    TETPrice: 0,
  };
}

export default {

  namespaced: true,

  state: getInitialState(),

  actions: {
    async getPrice({ commit }) {
      const res = await getPrice();
      if (res.status === 200 && res.data) {
        const { usd: price } = res.data['v-systems'];
        commit('save', { price: Number(price) });
      }
    },
    async getTETPrice({ commit }) {
      const res = await getTET();
      if (res.status === 200 && res.data && res.data.code === 0) {
        const { usd: TETPrice } = res.data.data.tetrisTokenExchange;
        commit('save', { TETPrice: Number(TETPrice) });
      }
    },
    async getCurrentSupply({ commit }) {
      const res = await getSupply();
      if (res.status === 200 && res.data && res.data.code === 0) {
        const supply = res.data.data.CirculatingSupply;
        commit('save', { supply: Number(supply) });
      }
    },
  },

  mutations: {
    save(state, data) {
      // console.log(data);
      Object.assign(state, data);
    },
  },
};
